import React from 'react'
import { Link } from 'gatsby'
import Loadable from '@loadable/component'
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const Banner = (props) => {
    const [display, setDisplay] = React.useState(false)
    React.useEffect(() => {
        setDisplay(true)
    }, [])

    // BannerOne loop start
    const banneronedata = props.banneronesData.map(
        (bannerone, index) => (
            <div className={bannerone.BgClass} key={index}>
                <div className="diplay-table">
                    <div className="display-table-cell">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-7">
                                    <h1>{bannerone.Title}</h1>

                                    <div className="center-wrap">
                                        <Link to={bannerone.BtnLink} className="btn-a">
                                            <div className="button">
                                                {bannerone.BtnName}
                                                {` `}
                                                <i className="fa fa-long-arrow-right"></i>
                                                <div className="mask" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
    // BannerOne loop END
    
    // Thumbs loop Start
    const thumbdata = props.thumbsData.map((thumb, index) => (
        <div className="owl-thumb-item" key={index}>
            <div className="glyph">
                <i className={thumb.ThumbIcon}></i>
            </div>
            <h3>{thumb.ThumbTitle}</h3>
            <p>{thumb.ThumbContent}</p>
        </div>
    ))

    // Thumbs loop END
    return (
        <React.Fragment>
            <div className="hompage-slides-wrapper">
                {display ? <OwlCarousel
                    className="owl-theme homepage-slides"
                    items={1}
                    touchDrag={true}
                    margin={0}
                    mouseDrag={true}
                    smartSpeed={10}
                    dotData={true}
                    dotsContainer={".owl-thumbs"}
                >
                    {banneronedata}
                </OwlCarousel> : '' }

                <div className="owl-thumbs">
                    {thumbdata}
                </div>
            </div>
        </React.Fragment>
    );
}

// Default Props
Banner.defaultProps = {
    banneronesData: [
        {
            BgClass: "single-slider-item slide-bg-1",
            TopTitle: "Clean & Creative",
            Title: "Un parc d'attraction sécurisé",
            Content:
                "Nous.",
            BtnLink:  "#works",
            BtnName: "Aller plus loin"
        },
        {
            BgClass: "single-slider-item slide-bg-2",
            TopTitle: "Clean & Creative",
            Title: "Un Hôtel haut standing",
            Content:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            BtnLink:  "#rooms",
            BtnName: "Aller plus loin"
        },
        {
            BgClass: "single-slider-item slide-bg-3",
            TopTitle: "Clean & Creative",
            Title: "Un Mini ZOO pitoresque",
            Content:
                "Alo Alo Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            BtnLink:  "#blogs",
            BtnName: "Aller plus loin"
        }
    ],
    thumbsData: [
        {
            ThumbIcon: "glyph-icon flaticon-015-humanpictos",
            ThumbTitle: "Parc d'Attraction",
            ThumbContent: "Offrez un cadre idéal récréatif à vos enfants.",
        },
        {
            ThumbIcon: "glyph-icon flaticon-006-panel",
            ThumbTitle: "Hotêl",
            ThumbContent: "Trouvez un hôtel situé dans une forêt pitoresque et très calme.",
        },
        {
            ThumbIcon: "glyph-icon flaticon-016-team",
            ThumbTitle: "Mini ZOO",
            ThumbContent: "Faites découvrir les différents animaux sauvages à vos proches dans un environnement sécurisé.",
        },
    ]
};

export default Banner
